import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import Games from '../Games';
import { addEyeAnimationsToSprite } from '../AnimationManager';

export default class Piece extends Phaser.GameObjects.Container {

  constructor(scene, spritename, hasFull, isAnimated, animationName, atlas = ABCyaPhaser.Images.DEFAULT_ATLAS) {
    super(scene);

    this.directionContainer = null;

    this.loc = { x: 0, y: 0 };
    this.isPlaced = false;
    this.spriteName = null;
    this.hasFull = false;
    this.isFull = false;
    this.previewScale = 0.4;

    this.isAnimated = false;
    this.lastAnimate = 0;
    this.animateWaiter = 0;

    this.menuIndex = null;
    this.submenuIndex = null;

    this.spriteName = spritename;
    this.hasFull = hasFull;
    this.isAnimated = isAnimated;
    this.animationName = animationName;
    this.lastAnimate = 2000;

    if (isAnimated) {
      this.sprite = this.scene.add.sprite(0, 0, atlas, spritename);

      if (gameData.game === Games.face || gameData.game === Games.pumpkin || gameData.game === Games.snowman) {
        addEyeAnimationsToSprite(this.sprite);
        this.sprite.play(`${animationName}_idle`);

        // center the sprite
        const center = this.sprite.getCenter();
        this.sprite.setPosition(-center.x, -center.y);
      }

      this.animateWaiter = Phaser.Math.Between(2400, 5500);
    }
    else {
      this.sprite = ABCyaPhaser.Images.addImage(0, 0, spritename, this, atlas);
    }

    if (this.hasFull) {
      this.previewScale = 0.45;
      this.isFull = false;
    }
    else {
      this.previewScale = 1.0;
    }
    this.scaleX = 0;
    this.scaleY = 0;

    ABCyaPhaser.Tweens.addTween(this, 120, { scaleX: this.previewScale, scaleY: this.previewScale }, Phaser.Math.Easing.Linear);

    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClick, this);
    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onRelease, this);

    // Make hit area everything so easier to pick up
    const minWidth = gameData.settings.MIN_ITEMWIDTH;
    const minHeight = gameData.settings.MIN_ITEMHEIGHT;

    let difW = minWidth - this.sprite.width;
    if (difW < 0) difW = 0;
    let difH = minHeight - this.sprite.height;
    if (difH < 0) difH = 0;

    this.setSize(this.sprite.width, this.sprite.height);
    const shape = new Phaser.Geom.Rectangle(-difW / 2, -difH / 2, this.sprite.width + difW, this.sprite.height + difH);
    this.setInteractive(shape, Phaser.Geom.Rectangle.Contains);

    this.add(this.sprite);
  };

  onClick() {
    this.emit('PICKUP_ITEM', this);
  };

  onRelease() {
    this.emit('RELEASE_ITEM', this);
  };

  startDragging(x, y) {
    this.x = x;
    this.y = y;
  };

  showPreviewSize() {
    if (!this.hasFull) return;
    if (!this.isFull) return;
    this.isFull = false;
    ABCyaPhaser.Tweens.addTween(this, 130, { scaleX: 0.45, scaleY: 0.45 }, Phaser.Math.Easing.Linear);
  };

  showFullSize() {
    if (!this.hasFull) return;
    if (this.isFull) return;
    if (!this.isFull) ABCyaPhaser.Tweens.addTween(this, 130, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Linear);
    this.isFull = true;
  };

  goAway() {
    this.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
    this.off(Phaser.Input.Events.GAMEOBJECT_POINTER_UP);
    ABCyaPhaser.Tweens.addTween(this, 220, { alpha: 0, scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Linear);
  };

  comeBack() {
    ABCyaPhaser.Tweens.addTween(this, 220, { alpha: 1, scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Linear);

    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClick, this);
    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onRelease, this);
  };

  turnLeft() {
    if (this.isAnimated) return;
    ABCyaPhaser.Tweens.addTween(this, 80, { scaleX: -1, scaleY: 1 }, Phaser.Math.Easing.Linear);
  };

  turnRight() {
    if (this.isAnimated) return;
    ABCyaPhaser.Tweens.addTween(this, 80, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Linear);
  };

  tick(time) {
    if (time - this.lastAnimate > this.animateWaiter) {
      this.sprite.play(this.animationName);
      this.lastAnimate = time;
      this.animateWaiter = Phaser.Math.Between(3400, 6500);
    }
  };
}